import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
  DataTableComponent,
  TableColumn,
} from '@shared/components/data-table/data-table.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { PurchaseOrderDetailItem } from '../../purchase-order-add/purchase-order-add.config';

@Component({
  selector: 'app-order-details-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DataTableComponent,
    ConfirmationDialogComponent,
  ],
  templateUrl: './order-details-dialog.component.html',
  styleUrl: './order-details-dialog.component.css',
})
export class OrderDetailsDialogComponent {
  @Input() visible = false;
  @Input() warehouseCode = '';
  @Input() warehouseName = '';
  @Input() orderItems: PurchaseOrderDetailItem[] = [];
  @Input() tableColumns: TableColumn[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}

